const validateMobileNo = (e: any) => {
  const re = /^[0-9\b]+$/;
  if (e.target.value === '' || re.test(e.target.value)) {
    return e.target.value
  }
  return false
}
export default validateMobileNo